module.exports = __webpack_public_path__ + "img/kk-linkedin.2e2e3218.png";